import { FC } from 'react';

interface ActionItemSkeletonProps {
  count?: number;
  dataTestId?: string;
}

const ActionItemSkeleton: FC<ActionItemSkeletonProps> = ({
  count = 9,
  dataTestId,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="home-action-skeleton__card"
          data-test-id={dataTestId ? `${dataTestId}-${index}` : undefined}
        >
          <div className="home-action-skeleton__left">
            <div className="home-action-skeleton__icon" />
            <div className="home-action-skeleton__title" />
          </div>

          <div className="home-action-skeleton__right">
            <div className="home-action-skeleton__button" />
            <div className="home-action-skeleton__button" />
          </div>
        </div>
      ))}
    </>
  );
};

export default ActionItemSkeleton;
